<template>
    <div class="container-fluid  pt-2" >


        <div class="row">
            <div class="col-md-6 col-6">

                <div class="text-left py-3">
                    <h4 class="text-weight-700 text-primary">   All Services </h4>
                </div>
            </div>
            <div class="col-md-6 col-6">
                <div class="text-right py-3">
                    <button v-if="userrole==='Admin'" v-on:click="NewServiceModal()" class="btn btn-primary" >Add Service</button>
                </div>
            </div>


        </div>
        <div class="row pb-3">
        <div class="col-6">
            <form>
                <div class="col-auto">


                    <div class="form-group has-search"><span class="fa fa-search form-control-feedback"></span> <input v-model="SearchService" type="text" placeholder="Search All Services" class="form-control border"></div>
                </div>
            </form>
        </div>
        <div class="col-6">

                <b-form inline>
                    <label class="mr-sm-2 p" >Sort by: </label>
                <b-form-select v-model="queryselected" :options="serviceoptions"  class="mb-2 mr-sm-2 mb-sm-0">
                    <!-- This slot appears above the options from 'options' prop -->





                </b-form-select>
            </b-form>


        </div>
        </div>
        <b-table
                sticky-header
                hover
                :items="items"
                :fields="fields"
                sort-icon-left
                responsive="sm"
                @row-clicked="RowSelected"

        >
            <template #cell(index)="data">
                <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                <span v-bind:style="{ background: data.bg_color }">{{ data.index + 1 }}</span>

            </template>
            <template #cell(service)="data">
                <p class="text-primary underline-primary">    {{ data.item.service }}</p>
            </template>

        </b-table>


        <b-modal ref="productmodal" id="modal-center"  hide-footer hide-header static>
            <div class="card">
                <div class="card-body">
                    <h5 class="text-center">Service Details</h5>
                    <table class="table table-striped">
                        <tbody>
                        <tr><td>Service:</td> <td>{{Selected_product.service}}</td> </tr>
                        <tr><td>Rates:</td> <td>{{convertCurrencyToLocal(Selected_product.cost)}}</td> </tr>

                        <tr><td>Date Updated:</td> <td>{{Selected_product.date_added}}</td> </tr>
                        </tbody>

                    </table>
                    <div class="btn-group">


                        <button  v-if="userrole === 'Admin'" class="btn btn-outline-danger rounded btn-sm mx-1" v-on:click="DeleteProd(Selected_product.id)" >Delete </button>
                        <button v-if="userrole === 'Admin'" class="btn btn-outline-primary rounded btn-sm mx-1" v-on:click="EditProdModal(Selected_product.id)">Edit </button>

                    </div>

                </div>

            </div>
        </b-modal>
        <!--product delete confirmation-->
        <b-modal ref="editproductmodal"  id="bv-modal-edit" hide-footer>
            <div class="text-center py-3">
                <h2 class="text-weight-700 text-primary">Edit Service {{Selected_product.product}}</h2>
            </div>
            <form>
                <div class="form-group">
                    <label>Service Title</label>
                    <input class="border form-control" :placeholder="Selected_product.product" v-model="editprodform.title" />
                </div>
                <div class="form-group">
                    <label>Rate</label>
                    <input class="border form-control" :placeholder="Selected_product.ppu" v-model="editprodform.ppu" />
                </div>
                <div class="form-group">
                    <label>Billing unit eg Per Hour</label>
                    <input class="border form-control" :placeholder="Selected_product.measuring_unit" v-model="editprodform.measuring" />

                </div>
                <div class="form-group">
                    <button v-on:click="UpdateProduct()" class="btn btn-primary">Submit</button>
                </div>
            </form>
        </b-modal>
        <b-modal ref="addprodmodal"  id="bv-modal-edit" hide-footer>
            <div class="text-center py-3">
                <h2 class="text-weight-700 text-primary">Add New Service</h2>
            </div>
            <form>
                <div class="form-group">
                    <label>Service Title</label>
                    <input class="border form-control" v-model="addprodform.title" />
                </div>
                <div class="form-group">
                    <label>Rate</label>
                    <input class="border form-control" v-model="addprodform.ppu" />
                </div>
                <div class="form-group">
                    <label>Billing unit eg Hour or service</label>
                    <input class="border form-control" v-model="addprodform.measuring" />

                </div>
                <div class="form-group">
                    <label>Please choose  Service Category</label>
                    <select data-placeholder="Select" v-model=addprodform.selectedcategory class="form-control form-control-sm" required>


                            <option v-for="servicecat in servicecats" v-bind:value="servicecat.id" >{{servicecat.name}}</option>


                    </select>


                </div>
                <div class="form-group">
                    <label>Service Track Code </label>
                    <input class="border form-control" v-model="addprodform.sku" />
                    <small>Unique code (sku)</small>

                </div>
                <div class="form-group">
                    <button v-on:click="AddService()" class="btn btn-primary">Submit</button>
                </div>
            </form>
        </b-modal>

    </div>
</template>

<script>
    export default{
        name: 'services',
        data(){
            return {
                allservices:'',
                product_in_services:'',
                show:true,
                services_id:'',
                Selected_product:'',
                todelete:'',
                restockform:{
                    quantity:'',
                    product_id:''
                },
                editprodform:{
                    title:'',
                    ppu:'',
                    measuring:'',
                    product_id:'',
                },
                addprodform:{
                    title:'',
                    ppu:'',
                    measuring:'',
                    sku:'',
                    selectedcategory:''
                },
                SearchService:'',
                servicecats:'',
                fields:[
                    'index',
                    { key: 'service', sortable: true },
                    { key: 'cost', sortable: true },
                    { key: 'date_added', sortable: true },



                ],
                items:[],
                queryselected:null,
                serviceoptions:[

                ],
                userrole:'',


            }
        },


        mounted(){
            this.GetServices();
            this.GetServicesCategory()
        },
        watch:{
            SearchService(before,after)
            {

               this.GetServices()

            },
            queryselected(before,after)
            {
                this.GetServices()
            },
        },
        methods:{

            RowSelected(items){
                this.Selected_product = items
                this.$refs['productmodal'].show();

            },

            GetServices()
            {

                axios.get('/api/services',{params: {search:this.SearchService,category_id:this.queryselected}})
                    .then(result => {
                        console.log(result.data);
                        let servicesarray = [];
                        this.product_in_services = result.data;
                        $.each(result.data,function(key,value)
                        {
                            servicesarray.push({
                                'id':value.id,
                                'cost':value.ppu,
                                'service':value.product,
                                'date_added': moment(value.created_at).fromNow(),
                                'bg_color':value.bg_color,
                            })
                        })
                        this.items = servicesarray;
                        this.userrole = result.data.userrole



                    });
            },
            GetServicesCategory()
            {

                axios.get('/api/services-category')
                    .then(result => {


                        let catselect = [
                            {text:"-- Most Relevant --",value:null},
                        ];
                        $.each(result.data,function (key,value) {
                            catselect.push(
                                {
                                    text:value.name,
                                    value: value.id,

                                }
                            );


                        });
                        this.serviceoptions = catselect;
                        this.servicecats = result.data;




                    });
            },

            NewServiceModal()
            {
                this.$refs['addprodmodal'].show();
            },


            AddService(){
                event.preventDefault();

                axios.post('/api/service/create',{title:this.addprodform.title,product_id:this.addprodform.product_id,ppu:this.addprodform.ppu,measuring_unit:this.addprodform.measuring,sku:this.addprodform.sku,category:this.addprodform.selectedcategory})
                    .then(result => {

                        this.GetServices();
                        if(result.data.status === 200) {
                            this.$refs['addprodmodal'].hide();
                            this.$toasts.push({
                                type: 'success',
                                message: result.data.message,
                            });
                            this.addprodform.title='';
                            this.addprodform.product_id='';
                            this.addprodform.ppu='';
                            this.addprodform.measuring='';

                        }
                        else {
                            this.$toasts.push({
                                type: 'error',
                                message: result.data.message,
                            });
                        }


                    });
            },
            UpdateProduct(){
                event.preventDefault();

                axios.post('/api/p_edit',{title:this.editprodform.title,product_id:this.editprodform.product_id,ppu:this.editprodform.ppu,measuring_unit:this.editprodform.measuring})
                    .then(result => {


                        if(result.data.status === 200) {
                            this.$refs['editproductmodal'].hide();
                            this.$toasts.push({
                                type: 'success',
                                message: result.data.message,
                            });
                            this.editprodform.title='';
                            this.editprodform.product_id='';
                            this.editprodform.ppu='';
                            this.editprodform.measuring='';
                            this.GetServices();

                        }
                        else {
                            this.$toasts.push({
                                type: 'error',
                                message: result.data.message,
                            });
                        }


                    });
            },
            EditProdModal(prod_id)
            {

                axios.get('/api/p_details',{params: {product_id:prod_id}})
                    .then(result => {
                        console.log(result.data);

                        this.Selected_product = result.data;
                        this.editprodform.product_id = this.Selected_product.id;

                        this.$refs['productmodal'].hide();
                        this.$refs['editproductmodal'].show();


                    });
            },
            DeleteProd(prod_id){

                axios.get('/api/p_delete',{params: {prod_id:prod_id}})
                    .then(result => {
                        if(result.data.status === 200) {
                            this.$toasts.push({
                                type: 'success',
                                message: result.data.message,

                            });
                            this.$refs['productmodal'].hide();
                            this.GetServices()
                        }
                        else {
                            this.$toasts.push({
                                type: 'error',
                                message: result.data.message,
                            });

                        }
                    });






            },

        
        }
    }
</script>


